const initialState = {
    data: {
        // delete in next release
        emails: {
            manualInput: "",
            list: [],
        },
        importedFiles: [], // delete in next release
        validFiles: [],
        invalidFilenames: [],
        selectedContacts: [],
    },
    status: "editing",
};

export default initialState;